<div class="navbar">
  <ng-content />
</div>
